// Styles
import "./delete-confirm-modal.scss";
// Components
import { Modal } from "../../../../../../../../../../shared/components/modal/Modal";
import { CompactButton } from "../../../../../../../../../../shared/components/buttons/compact-button/CompactButton";

interface Props {
	isOpen: boolean;
	title?: string;
	isLoading?: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

export const DeleteConfirmModal = ({
	isOpen,
	title,
	isLoading = false,
	onCancel,
	onConfirm,
}: Props) => {
	return (
		<Modal isOpen={isOpen} onClose={onCancel} title='Видалити чат?' size='sm'>
			<p className='delete-confirm-modal__hint'>
				{title &&
					`Ви впевнені, що хочете видалити «${title}»? Цю дію не можна скасувати.`}
			</p>
			<div className='delete-confirm-modal__actions'>
				<CompactButton onClick={onCancel} type='button' theme='default'>
					Скасувати
				</CompactButton>
				<CompactButton
					onClick={onConfirm}
					type='button'
					unactive={isLoading}
					theme='red'>
					Видалити
				</CompactButton>
			</div>
		</Modal>
	);
};
